import React, { Fragment } from 'react';

import { Row } from '@BICE_Vida/scp-components';

import styles from './AvailablePlanCoverage.module.scss';

import { planModalPrexistancesText } from '../../utils/generalTexts';
import { Col } from '@/designSystem/Container/Container';
import Accordion from '@/designSystem/Accordion';

function Prexistances() {
  return (
    <Fragment>
      <div className={styles.plans_details_information_container}>
        <Row justify="center">
          <Col sm={12} md={12} lg={12}>
            <div className={styles.plan_prexistances}>
              {planModalPrexistancesText.coverages.map((it, idx) => (
                <Accordion key={idx} title={it.title} outline>
                  <div className={styles.plan_prexistance_description}>
                    {it.content.map((content, idx) =>
                      content.type === 'p' ? (
                        <p key={idx}>{content.value}</p>
                      ) : content.type === 'list' ? (
                        <ul>
                          {content.value.map((li, idx) => (
                            <li key={idx}>{li}</li>
                          ))}
                        </ul>
                      ) : (
                        ''
                      )
                    )}
                  </div>
                </Accordion>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
}

export default Prexistances;
